/* Panel „Ułatwienia dostępu”: zapisuje ustawienia w localStorage i nakłada je jako atrybuty data-a11y-* na <html>.
   Te same atrybuty nakłada wcześniej skrypt w <head> (layout/theme.liquid), żeby strona nie mignęła. */
(() => {
  const STORAGE_KEY = 'kopyto-a11y';
  const PROFILES = {
    adhd: { motion: 'off', headings: 'on', links: 'on' },
    epilepsy: { motion: 'off', saturation: 'low' },
    dyslexia: { font: 'on', line: '15', word: 'm', align: 'left' },
    vision: { text: '150', contrast: 'on', cursor: 'black', links: 'on' }
  };

  const root = document.documentElement;
  const form = document.querySelector('[data-a11y-form]');
  if (!form) return;

  const load = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (error) {
      return {};
    }
  };

  let settings = load();

  const save = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch (error) {}
  };

  const pauseVideos = () => {
    document.querySelectorAll('video').forEach((video) => video.pause());
  };

  const apply = () => {
    Array.from(root.attributes).forEach((attribute) => {
      if (attribute.name.startsWith('data-a11y-')) root.removeAttribute(attribute.name);
    });

    Object.entries(settings).forEach(([name, value]) => root.setAttribute(`data-a11y-${name}`, value));

    const reduce = settings.motion === 'off';
    if (reduce) pauseVideos();
    document.dispatchEvent(new CustomEvent('kopyto:a11y-motion', { detail: { reduce } }));
  };

  const isProfileActive = (profile) => Object.entries(PROFILES[profile]).every(([name, value]) => settings[name] === value);

  const sync = () => {
    form.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = (settings[input.name] || 'default') === input.value;
    });

    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.checked = settings[input.name] === input.value;
    });

    form.querySelectorAll('[data-a11y-profile]').forEach((button) => {
      button.setAttribute('aria-pressed', isProfileActive(button.dataset.a11yProfile));
    });
  };

  const speechSupported = 'speechSynthesis' in window;
  const speechLang = { pl: 'pl-PL', en: 'en-GB', de: 'de-DE' }[(root.lang || 'pl').slice(0, 2)] || root.lang;
  let readingElement = null;

  const stopSpeech = () => {
    if (speechSupported) speechSynthesis.cancel();
    readingElement?.classList.remove('kopyto-a11y-reading');
    readingElement = null;
  };

  const toChunks = (text) => {
    const sentences = text.replace(/\s+/g, ' ').trim().match(/[^.!?]+[.!?]*/g) || [];

    return sentences.reduce((chunks, sentence) => {
      const last = chunks[chunks.length - 1];

      if (last && (last + sentence).length <= 200) {
        chunks[chunks.length - 1] = last + sentence;
      } else {
        chunks.push(sentence.trim());
      }

      return chunks;
    }, []);
  };

  const speak = (text, element) => {
    if (!speechSupported || !text) return;
    stopSpeech();

    const voice = speechSynthesis.getVoices().find((item) => item.lang.toLowerCase().startsWith(speechLang.slice(0, 2)));
    const chunks = toChunks(text);

    chunks.forEach((chunk, index) => {
      const utterance = new SpeechSynthesisUtterance(chunk);
      utterance.lang = speechLang;
      if (voice) utterance.voice = voice;
      if (index === chunks.length - 1) utterance.onend = () => element?.classList.remove('kopyto-a11y-reading');
      speechSynthesis.speak(utterance);
    });

    if (element) {
      readingElement = element;
      element.classList.add('kopyto-a11y-reading');
    }
  };

  const INTERACTIVE = 'a, button, input, select, textarea, summary, [role="button"]';
  const READABLE = 'p, li, h1, h2, h3, h4, h5, h6, blockquote, figcaption, td, th, dd, dt, label';

  document.addEventListener('click', (event) => {
    if (settings.speech !== 'on' || event.target.closest(`#kopyto-a11y-panel, ${INTERACTIVE}`)) return;

    const element = event.target.closest(READABLE);
    if (element) speak(element.textContent, element);
  });

  document.addEventListener('focusin', (event) => {
    if (settings.speech !== 'on' || event.target.closest('#kopyto-a11y-panel')) return;

    const element = event.target.closest(INTERACTIVE);
    if (!element) return;

    speak(element.getAttribute('aria-label') || element.labels?.[0]?.textContent || element.textContent || element.placeholder);
  });

  window.addEventListener('pagehide', stopSpeech);

  if (!speechSupported) {
    form.querySelectorAll('[data-a11y-speech-section] :is(input, button)').forEach((control) => {
      control.disabled = true;
    });
    form.querySelector('[data-a11y-speech-unsupported]').hidden = false;
  }

  const update = () => {
    save();
    apply();
    sync();
    if (settings.speech !== 'on') stopSpeech();
  };

  form.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.name) return;

    const value = input.type === 'checkbox' ? (input.checked ? input.value : null) : input.value;

    if (!value || value === 'default') {
      delete settings[input.name];
    } else {
      settings[input.name] = value;
    }

    update();
  });

  form.addEventListener('click', (event) => {
    const profileButton = event.target.closest('[data-a11y-profile]');

    if (profileButton) {
      const profile = profileButton.dataset.a11yProfile;
      const active = isProfileActive(profile);

      Object.entries(PROFILES[profile]).forEach(([name, value]) => {
        if (active) {
          delete settings[name];
        } else {
          settings[name] = value;
        }
      });

      update();
      return;
    }

    if (event.target.closest('[data-a11y-reset]')) {
      settings = {};
      update();
      return;
    }

    if (event.target.closest('[data-a11y-read-page]')) {
      const blocks = Array.from(document.querySelectorAll(`main :is(${READABLE})`))
        .filter((block) => block.offsetParent !== null && !block.parentElement.closest(READABLE))
        .map((block) => block.textContent.replace(/\s+/g, ' ').trim())
        .filter(Boolean)
        .map((text) => (/[.!?:]$/.test(text) ? text : `${text}.`));

      speak(blocks.join(' '));
      return;
    }

    if (event.target.closest('[data-a11y-stop]')) stopSpeech();
  });

  sync();
  if (settings.motion === 'off') pauseVideos();
})();
